var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChevronRightPurple(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.64596 6L0.728859 10.7197C0.423714 11.0126 0.423714 11.4874 0.728859 11.7803C1.034 12.0732 1.52874 12.0732 1.83389 11.7803L7.24825 6.58336C7.58392 6.26118 7.58391 5.73882 7.24825 5.41664L1.83389 0.21967C1.52874 -0.0732236 1.03401 -0.0732236 0.72886 0.21967C0.423714 0.512563 0.423714 0.987437 0.72886 1.28033L5.64596 6Z",
    fill: "#883E89"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRightPurple);
export default __webpack_public_path__ + "static/media/chevron-right-purple.10418f5f6dd4a11a64cb49a3082cfcec.svg";
export { ForwardRef as ReactComponent };